import axios from 'axios';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

// Отмечает первый вход на сервере. Окно «Завершите регистрацию» убрано
// (решение 22.10): в первую минуту новичку хватает списка «С чего начать»
// на Главной, а почту и профиль можно заполнить позже в «Моих данных».
export default function FirstVisit() {
    const handledRef = useRef(false);
    const myinfo = useSelector((state) => state.getMayInfoReducer?.myinfo);

    useEffect(() => {
        if (!(myinfo instanceof Object) || myinfo.firstVisit !== false || handledRef.current) return;

        handledRef.current = true;
        axios.post('updateVisit/api').catch((error) => console.log(error));
    }, [myinfo]);

    return null;
}
